import { PaperPlaneTilt, EnvelopeSimple, ChatCircleText, Clock } from "@phosphor-icons/react";
import { PageIntro } from "@/components/site/PageIntro";
import { Reveal } from "@/components/site/Reveal";
import { useSeo } from "@/components/site/Seo";

const SUPPORT_EMAIL = "support@velora.ai";

export default function SupportPage() {
  useSeo({
    title: "Support & Contact",
    description:
      "Contact the Velora Intelligence team. Reach us by email for questions, feedback or help with the AI crypto intelligence app.",
    path: "/support",
  });
  return (
    <main data-testid="support-page">
      <PageIntro
        label="Support"
        title="We're here to help"
        desc="Have a question, some feedback, or need a hand getting started with Velora Intelligence? Reach out and our team will get back to you."
      />

      <section className="relative z-10 mx-auto max-w-4xl px-4 py-16 sm:px-6 md:py-24">
        <div className="grid gap-6 md:grid-cols-2">
          <Reveal>
            <div className="card-hover-glow flex h-full flex-col rounded-3xl border border-teal-500/25 bg-gradient-to-br from-teal-500/10 to-transparent p-8">
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-teal-500/15 text-teal-400">
                <EnvelopeSimple size={24} weight="duotone" />
              </span>
              <h2 className="mt-6 font-display text-xl font-bold text-white">
                Email support
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-white/55">
                The fastest way to reach us. Send your question and we'll reply
                as soon as we can.
              </p>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                data-testid="support-email-cta"
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-teal-500 px-6 py-3 text-sm font-semibold text-midnight transition-transform duration-300 hover:scale-[1.03] hover:bg-teal-400"
              >
                <PaperPlaneTilt size={18} weight="fill" />
                Email {SUPPORT_EMAIL}
              </a>
            </div>
          </Reveal>

          <Reveal delay={1}>
            <div className="flex h-full flex-col gap-4">
              <div className="rounded-3xl border border-white/8 bg-white/[0.02] p-6">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-white/6 text-teal-400">
                  <ChatCircleText size={20} weight="duotone" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-white">
                  What to include
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55">
                  A short description of your question, the device you're using
                  and any relevant screenshots help us assist you faster.
                </p>
              </div>
              <div className="rounded-3xl border border-white/8 bg-white/[0.02] p-6">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-white/6 text-teal-400">
                  <Clock size={20} weight="duotone" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-white">
                  Response times
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55">
                  We aim to respond to every message. Response times may vary
                  depending on volume.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={2}>
          <p className="mt-8 rounded-2xl border border-white/8 bg-white/[0.015] p-5 text-center text-xs text-white/45">
            Velora Intelligence provides informational and analytical tools only
            and cannot offer financial, investment, legal or tax advice through
            support.
          </p>
        </Reveal>
      </section>
    </main>
  );
}
